module.exports = __webpack_public_path__ + "static/img/bcg.fcdb289b.webp";